class s{constructor(s,e,i){this.device=s,this.inverseBindPose=e,this.boneNames=i}}export{s as Skin};
